
import React from "react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { SidebarFileItem } from "./SidebarFileItem";
import { ResourceFile } from "./types";

interface SidebarFileItemListProps {
  files: ResourceFile[];
  completedFiles: {[key: string]: boolean};
  currentFileIndex: number;
  isTrainee: boolean;
  isAdmin: boolean;
  isFileLocked: (index: number) => boolean;
  handleFileChange: (index: number) => void;
}

export function SidebarFileItemList({
  files,
  completedFiles,
  currentFileIndex,
  isTrainee,
  isAdmin,
  isFileLocked,
  handleFileChange
}: SidebarFileItemListProps) {
  return (
    <div className="flex-1 min-h-0">
      <ScrollArea className="h-full">
        <div className="p-4 space-y-2">
          {files.map((file, index) => (
            <SidebarFileItem
              key={file.id}
              file={file}
              index={index}
              currentFileIndex={currentFileIndex}
              isLocked={isFileLocked(index)}
              isCompleted={completedFiles[file.id] || false}
              isTrainee={isTrainee}
              isAdmin={isAdmin}
              onFileSelect={handleFileChange}
            />
          ))}
        </div>
      </ScrollArea>
    </div>
  );
}
